export default __webpack_public_path__ + "static/media/024-archive.f6658935.svg";